module.exports = __webpack_public_path__ + "static/img/img-bg-contact-us.229cfd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-bg-contact-us.png
// module id = Erp6
// module chunks = 36